import { FLAVORS, STARTING_PRICE } from '../../config/site';
import { LandingProductCard } from './LandingProductRow';

export default function Flavors() {
  return (
    <section id="flavors" className="py-16 md:py-24 bg-cream scroll-mt-[132px]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-inter text-sm md:text-base font-medium tracking-[0.3em] uppercase text-text-primary mb-3">
            OUR FLAVORS
          </h2>
          <p className="font-inter text-xs tracking-[0.2em] uppercase text-text-muted">
            {STARTING_PRICE}
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {FLAVORS.map((f) => (
            <LandingProductCard key={f.id} name={f.name} detail={f.detail} image={f.image} colors={[]} />
          ))}
        </div>
      </div>
    </section>
  );
}
